import { Directive, TemplateRef, Optional } from '@angular/core';

/**
 * Represents the template directive of the PanelBar which helps to customize the item content.
 */
@Directive({
  standalone: false,
  selector: '[kendoPanelBarItemTemplate]',
})
export class PanelBarItemTemplateDirective {
  public templateRef: TemplateRef<any>;

  constructor(@Optional() templateRef: TemplateRef<any>) {
    this.templateRef = templateRef;
  }
}
